import { ISimpleTableField, simpleTableSortFn } from "@asup/simple-table";
import { RenderReleaseStatus } from "../RenderReleaseStatus";
import { TlfItemTableFlags } from "../TlfItemTableFlags";
import { TlfItemTableLinkCell } from "../TlfItemTableLinkCell";
import { TlfItemTableTagsCell } from "../TlfItemTableTagsCell";
import { TlfItemVersions } from "../TlfItemVersions";
import { filterTemplates } from "./filterTemplates";
import { searchTemplatesWithText } from "./searchTemplatesWithText";

export const templateHeaders: ISimpleTableField[] = [
  {
    name: "azsolIdVersion",
    label: "AZSOL ID/Version",
    width: "110px",
    canColumnFilter: true,
    sortFn: simpleTableSortFn,
    searchFn: searchTemplatesWithText,
    filterOutFn: filterTemplates,
    renderFn: TlfItemTableLinkCell,
  },
  {
    name: "tlfTags",
    label: "Tags",
    width: "200px",
    canColumnFilter: true,
    renderFn: TlfItemTableTagsCell,
  },
  { name: "flags", label: "", width: "50px", renderFn: TlfItemTableFlags },
  {
    name: "domain",
    label: "Domain",
    width: "100px",
    canColumnFilter: true,
    sortFn: simpleTableSortFn,
  },
  {
    name: "taVersionsAvailable",
    label: "TA Versions Available",
    width: "200px",
    canColumnFilter: true,
    renderFn: TlfItemVersions,
  },
  {
    name: "tocLabel",
    label: "Title",
    width: "550px",
    canColumnFilter: true,
    sortFn: simpleTableSortFn,
  },
  {
    name: "type",
    label: "Type",
    width: "80px",
    canColumnFilter: true,
    sortFn: simpleTableSortFn,
  },
  {
    name: "releaseStatus",
    label: "Status",
    width: "80px",
    canColumnFilter: true,
    sortFn: simpleTableSortFn,
    renderFn: RenderReleaseStatus,
  },
  {
    name: "releaseDate",
    label: "Release date",
    width: "100px",
    canColumnFilter: true,
    sortFn: simpleTableSortFn,
  },
  {
    name: "decommissionDate",
    label: "Decommission date",
    width: "100px",
    canColumnFilter: true,
    sortFn: simpleTableSortFn,
  },
  {
    name: "additionalInformation",
    label: "Additional information",
    width: "150px",
    canColumnFilter: true,
  },
];
